if (!customElements.get('bread-crumbs')) {
	class BreadCrumbs extends HTMLElement {
		constructor() {
			super();
		}
		
    renderItems = () => {
      let items = ``;            
      for (let i = this.breadcrumbHistory.length - 1; i > 0 ; i--) {        
        const x = this.breadcrumbHistory[i];
        
        if (x.includes('/collections') && x !== window.location.href && !items.includes(`/collections`)) {
          items += (`
            <intersection-loader 
              data-url="/collections${x.split('/collections')[1]}"
              data-section-id="breadcrumb-collection"
              class="!inline-flex items-center w-max"
            >
              <span class="block h-4 w-12 bg-alabaster rounded"></div>
            </intersection-loader>
          `)
          break;
        }

        if (x.includes('/search') && x !== window.location.href && !items.includes(`/search`)) {
          items += (`
            <intersection-loader 
            data-url="/search${x.split('/search')[1]}"
            data-section-id="breadcrumb-search"
              class="!inline-flex items-center w-max"
            >
              <span class="block h-4 w-12 bg-alabaster rounded"></div>
            </intersection-loader>
          `)
          break;
        }
      } 
            
      return items;
    }
    
		connectedCallback() {
      this.breadcrumbHistory = [...new Set(sessionStorage.getItem('breadcrumbs')?.split(',') ?? '')];
      this.querySelector('ul').insertAdjacentHTML(`beforeend`, `
        ${this.renderItems()}
        ${window.location.pathname.includes('/products') ? 
        `
          <li>
            <span class="capitalize">
              ${document.querySelector('[data-title]').innerText.toLowerCase()}
            </span>
          </li>
        ` : ''
        } 
      `);
    }

	}
	customElements.define('bread-crumbs', BreadCrumbs);
}

trackPagesForBreadcrumbs = () => {
  if (sessionStorage.getItem('breadcrumbs')?.length) {
    if (sessionStorage.getItem('breadcrumbs').includes(window.location.href) || window.location.pathname === '/') return;
    const breadcrumbArray = sessionStorage.getItem('breadcrumbs').split(',');
    breadcrumbArray.push(window.location.href);
    sessionStorage.setItem('breadcrumbs', breadcrumbArray.slice(-5, breadcrumbArray.length))?.join(',');
    return;
  }
  
  if (window.location.pathname === '/') return;
  sessionStorage.setItem('breadcrumbs', window.location.href);
}

(() => {
  trackPagesForBreadcrumbs();
}) ();
